<template>
  <div class="profile-list px-2xl">
    <div
      class="profile-list--item"
      v-for="profile in profiles"
      :key="profile.title"
    >
      <div class="profile-list--item__image">
        <img :src="`${$imageFolder}${profile.image}`" alt="" />
        <div class="profile-list--item__info text-left">
          <h2 v-text="profile.title"></h2>
          <h3 v-text="profile.sub_title"></h3>
          <h5 class="pt-l text--l" v-text="profile.summary"></h5>
          <a
            class="readmore inline-block mt-2xl text--xs"
            :class="[profile.extra ? 'active' : '']"
            href="#p"
            @click.prevent.capture.stop="toggleExtra($event, profile)"
          >
            <span>Read more about {{ profile.title.split(" ")[0] }}</span>
            <i
              class="fal"
              :class="[profile.extra ? 'fa-times' : 'fa-chevron-right']"
            ></i>
          </a>
        </div>
      </div>
      <transition name="slide-down" appear>
        <div
          v-if="profile.extra"
          class="profile-list--item__extra text-left"
          :class="[profile.extra ? 'open' : '', 'mode-' + extraMode]"
        >
          <i
            @click="profile.extra = false"
            class="closebtn pointer fal fa-times"
          ></i>
          <h2
            class="heading__2 pt-xl pb-l"
            v-text="`About ${profile.title.split(' ')[0]}`"
          ></h2>
          <div v-html="profile.content"></div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    children: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      profiles: [],
      extraMode: "bottom"
    };
  },
  created() {
    this.$set(
      this,
      "profiles",
      _.map(this.children, profile => {
        return Object.assign({ extra: false }, profile);
      })
    );
  },
  methods: {
    toggleExtra(e, profile) {
      console.log("E>>> ", e.target.getBoundingClientRect());
      let rect = e.target.getBoundingClientRect();
      this.$set(
        this,
        "extraMode",
        window.innerHeight - rect.bottom > 400 ? "bottom" : "top"
      );
      profile.extra = !profile.extra;
    }
  }
};
</script>

<style lang="stylus" scoped>
lt_orange = #f2c572
.profile-list
  _flex(row, wrap, flex-start, space-between)
  .profile-list--item__extra.open
    padding 6vh 12%
    position absolute
    background #fff
    z-index 12
  &--item
    flex 0 0 50%
    margin-bottom 20px
    &:nth-child(odd)
      border-right 10px solid #fff
    &:nth-child(even)
      border-left 10px solid #fff
    position relative
    +below(1200px)
      flex 0 0 100%
    &__image
      z-index 5
      overflow hidden
      position relative
      display flex
      // +portrait()
      //   max-height 70vh
      +above(1100px)
        max-height 70vh
      img
        max-width 100%
        max-height 100%
        /.el-size--small &
          max-width 150%
    &__info
      position absolute
      top 50%
      left 50%
      transform translate(15%, -50%)
      max-width 42%
      z-index 6
      color #fff
      h2
        +above(1200px)
          font-size responsive 26px 38px
          font-range 415px 1900px
      h3
        +above(1200px)
          font-size responsive 16px 18px
          font-range 415px 1900px
      h5
        max-width 77%
        +above(1200px)
          font-size responsive 14px 18px
          font-range 415px 1900px
        color #a3d6f7
      /.el-size--small &
        position static
        transform none
        max-width initial
        width 100%
        background gray_9
        padding 10vmin
        margin-top -4px
      a
        position relative
        color #fff
        opacity 0.65
        transition opacity 0.1s ease-out
        &:after
          content ''
          width 25%
          height 1px
          background gray_4
          position absolute
          left 0
          bottom 0
          transform translate(0, 2px)
          transition width 0.3s ease-out-back, background 0.3s ease-out
        span
          display inline-block
          padding-bottom 3px
        i
          position relative
          transition transform 0.25s ease-out-back
          transform rotate(0deg)
          transform-origin 50% 50%
          width 16px
          height 16px
          text-align center
          line-height 1.3
          margin-left 3px
          &.fa-chevron-right
            font-size 80%
          &.fa-times
            transform rotate(180deg)
        &:hover
          opacity 1
          &:after
            width 90%
        &.active
          opacity 1
          &:after
            width 90%
            background gray_2
          span
            opacity 0.65
    &__extra
      // transition max-height 0.8s ease-out, padding 0.8s ease-out
      transform translateZ(0)
      backface-visibility hidden
      will-change max-height, padding
      overflow hidden
      .closebtn
        position absolute
        top 10px
        right 10px
        color gray_6
        width 4vmin
        height 4vmin
        font-size responsive 18px 22px
      h2
        position relative
        &:before
          content ''
          width 10%
          height 1px
          background gray_3
          position absolute
          top 0
          left 0
</style>
